import React from 'react'

function PostBanner({ Cateogary, Headline, image, Content, slug }) {
    // Content.substring(0, 200)
    return (
        <div className="item">
            <div className="row slider-info">
                <div className="col-lg-8 message-info align-self">
                    <a href={`/cateogary/${Cateogary}`}><span className="label-blue mb-sm-4 mb-3">{Cateogary}</span></a>
                    <a href={`/posts/${slug}`}><h1 className="title-big mb-4">{Headline}...</h1></a>
                    {/* <p className="message">Some Post [Length - 364] ....</p> */}
                    <a href={`/posts/${slug}`}><p className="message">{Content.substring(0, 200)}</p></a>
                </div>
                <div className="col-lg-4 col-md-8 img-circle mt-lg-0 mt-4">
                    <img src={image} className="img-fluid radius-image-full" style={{ height: '23em' }} alt="client" />
                </div>
            </div>
        </div>
    )
}

export default PostBanner
